import { Modal } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GoalSelection } from '@hero/organisms';

function MessageLibraryModal({ isOpen, onClose, onClick }) {
  const { t } = useTranslation();
  const [messageLibrary, setMessageLibrary] = React.useState({});

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={t('messageLibrary')}
      primaryButtonProps={{
        children: t('chooseThisMessage'),
        onClick: () => {
          onClick(messageLibrary);
          onClose();
        },
        disabled: !messageLibrary.message || !messageLibrary.occasion
      }}
      secondaryButtonProps={{
        children: t('cancel')
      }}
    >
      <GoalSelection setGoal={setMessageLibrary} />
    </Modal>
  );
}

export { MessageLibraryModal };
